import React, { forwardRef, ForwardRefRenderFunction, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box, TextField } from '@mui/material';
import { BaseTextFieldSize, SxWidth } from '@/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateInfoProps, DateInfoRef, DateInfoViewModel } from './types';
import { Dayjs } from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

const DesktopDatePickerInfo: ForwardRefRenderFunction<DateInfoRef, DateInfoProps> = (props, ref) => {
  const { DefaultValue, OnChange, Label } = props;
  const [viewModel, setViewModel] = useState<DateInfoViewModel>({
    Value: DefaultValue,
  });

  const locales = ['en', 'zh-cn'];

    type LocaleKey = (typeof locales)[number];

    const [locale, setLocale] = useState<LocaleKey>('zh-cn');

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
            <Box sx={{ mt: 2, ...SxWidth }}>
                <DesktopDatePicker
                    label={Label}
                    inputFormat="YYYY/MM/DD"
                    renderInput={(params) => (
                      <TextField {...params} size={BaseTextFieldSize} fullWidth />
                    )}
                    value={DefaultValue}
                    onChange={(e: Dayjs | null) => {
                      viewModel.Value = e;
                      const value = { ...viewModel };
                      setViewModel(value);
                      OnChange(value.Value);
                    }}
                />
            </Box>
        </LocalizationProvider>
    );
};

export default forwardRef(DesktopDatePickerInfo);
